import ReactSelect from "components/Form/Select/Select";
import React, { useEffect, useState } from "react";
import { Button, Card, CardBody, CardHeader, CardTitle, Col, Container, FormGroup, Input, Label, Modal, Row } from "reactstrap";
import useForm from "lib/useForm";
import DataTableEcommerce from "../DataTableEcommerce/DataTableEcommerce";
import FormTipoPreco from "../FormTipoPreco/FormTipoPreco";
import rotas from "services/rotas";
import rest from "lib/rest";
import Swal from "sweetalert2";
import Loading from "lib/loading";
import NumberFormat from "react-number-format";

const FormProdutosEcommerce = ({closeModal}) => {

  const colunas = [{
    dataField: '',
    text: '',
    headerStyle: { cursor: 'default' },
    width: '45px',
    checkbox: true,
    visible: true
  }, {
    dataField: 'produto_id',
    text: 'Código',
    headerStyle: { cursor: 'default' },
    width: '75px',
    checkbox: false,
    visible: true
  }, {
    dataField: 'cod_barras',
    text: 'Cód Barras',
    headerStyle: { cursor: 'default' },
    width: '110px',
    checkbox: false,
    visible: true
  }, {
    dataField: 'produto',
    text: 'Produto',
    headerStyle: { cursor: 'default' },
    width: '250px',
    checkbox: false,
    visible: true
  }, {
    dataField: 'prod_prvenda',
    text: 'Pr.Venda',
    headerStyle: { cursor: 'default' },
    bodyStyle: { className: "border-left" },
    width: '6.5rem',
    checkbox: false,
    visible: true,
    currency: true
  }, {
    dataField: 'prod_prpromocao',
    text: 'Pr.Promoção',
    headerStyle: { cursor: 'default' },
    bodyStyle: { className: "border-right" },
    width: '6.5rem',
    checkbox: false,
    visible: true,
    currency: true
  }, {
    dataField: 'porc_categ',
    text: '%',
    headerStyle: { cursor: 'default' },
    width: '6.5rem',
    checkbox: false,
    visible: true
  }, {
    dataField: 'valor_categ',
    text: 'R$',
    headerStyle: { cursor: 'default' },
    bodyStyle: { className: "border-right" },
    width: '6.5rem',
    checkbox: false,
    visible: true
  }, {
    dataField: 'porc_prod',
    text: '%',
    headerStyle: { cursor: 'default' },
    width: '6.5rem',
    checkbox: false,
    visible: true
  }, {
    dataField: 'valor_prod',
    text: 'R$',
    headerStyle: { cursor: 'default' },
    bodyStyle: { className: "border-right" },
    width: '6.5rem',
    checkbox: false,
    visible: true
  }, {
    dataField: 'venda_ecommerce',
    text: 'Venda',
    headerStyle: { cursor: 'default' },
    width: '6.5rem',
    checkbox: false,
    visible: true,
    editable: false,
    currency:true
  }, {
    dataField: 'promocao_ecommerce',
    text: 'Promoção',
    headerStyle: { cursor: 'default' },
    width: '6.5rem',
    checkbox: false,
    visible: true,
    editable: false,
    currency:true
  }]

  const listaTipoFiltro = [{
    id: 1,
    title: 'Produto'
  }, {
    id: 2,
    title: 'Categoria'
  }]

  const initialForm = {
    tipoPreco: {
      id: '',
      title: ''
    },
    tipoFiltro: {
      id: '',
      title: ''
    },
    categoria_id: {
      id: '',
      title: ''
    },
    filial_id: {
      id: '',
      title: ''    
    },
    formValido: 'N',
    produto: '',
    prod_saldo: 'N',
    pmc: 'N',
    promocional: 'N',
    preco_reajustar:'',    
    novo_porc: '0',
    novo_valor: '0'
  }

  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(initialForm);
  const [listaLojas, setListaLojas] = useState([])
  const [listaCategoria, setListaCategoria] = useState([]);
  const [listaTipoPreco, setListaTipoPreco] = useState([]);
  const [listaProdutos, setListaProdutos] = useState([])
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    listarLojas();
    listarCategorias();
    listarTipoPreco();
  }, [])


  useEffect(() => {
    if (form.tipoFiltro.id == 1) {
      let frm = form;
      form.categoria_id = {
        id: '',
        title: ''
      }
      setForm(frm);
    }

    if (form.tipoFiltro.id == 2) {
      let frm = form;
      form.produto = '';
      setForm(frm);
    }
  }, [form.tipoFiltro])

  const listarLojas = () => {
    const url = rotas.lojas;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if ((ret.success) && (ret.success == 'S')) {
        let lista = [];

        ret.lista.map(lst => {
          lista.push({
            id: lst.filial_id,
            title: lst.fantasia
          })
        })
        setListaLojas(lista);
      }
    })
  }

  const listarTipoPreco = () => {
    const url = rotas.ecommerceTipoPreco;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if ((ret.success) && (ret.success == 'S')) {
        let lista = [];

        ret.lista.map(ret => {
          lista.push({
            id: ret.tipo_preco_id,
            title: ret.descricao
          })
        })
        setListaTipoPreco(lista);
      }
    })

  }

  const listarCategorias = () => {
    const url = rotas.categoriaProduto;

    const retorno = rest.get(url);

    retorno.then(ret => {
      if ((ret.success) && (ret.success == 'S')) {
        let lista = [];

        ret.lista.map(lst => {
          lista.push({
            id: lst.categoria_id,
            title: lst.categoria
          })
        })
        setListaCategoria(lista);
      }
    })
  }

  const listarProdutos = () => {
    if ((form.tipoPreco.id == "") ||
      (form.filial_id.id == "") ||
      (form.tipoFiltro.id == "") ||
      ((form.categoria_id.id == "") && (form.tipoFiltro == '1')) ||
      ((form.produto == "") && (form.tipoFiltro == '2'))) {
      Swal.fire('Atenção', 'Por favor preencha os campos obrigatórios!', 'warning');

      let frm = {...form};

      frm.formValido = 'N';

      setForm(frm);
      return;
    }

    setListaProdutos([]);
    setLoading(true);

    const url = rotas.ecommerceProdutos;

    let filtro = '';

    if (form.categoria_id.id != '') {
      filtro = '&categoria_id=' + form.categoria_id.id;
    }

    if (form.produto != '') {
      filtro = '&produto=' + form.produto
    }

    if (form.prod_saldo == "S") {
      filtro += '&prod_saldo=S';
    }

    if (form.pmc == "S") {
      filtro += '&pmc=S';
    }

    if (form.promocional == "S") {
      filtro += '&promocional=S';
    }

    const retorno = rest.get(url + '?filial_id=' + form.filial_id.id + filtro);

    retorno.then(ret => {
      if (ret.success == 'S') {
        if(ret.lista.length == 0){
          Swal.fire('Atenção', 'Nenhum produto encontrado', 'info');  
        }

        ret.lista.map(linha => {
          linha.checked = false;
        })
      } else {
        Swal.fire('Erro', 'Erro na pesquisa de produtos!', 'error');
      }
      setListaProdutos(ret.lista);
      setLoading(false);
    })
  }

  const checkAll = (value) => {
    let dt = [...listaProdutos];

    dt.map(linha => {
      linha.checked = value
    })

    setListaProdutos(dt);
  }

  const onChangeReajuste = (e) =>{
    let frm = form;

    if(e.target.id == 'venda'){
      frm.preco_reajustar = 'V';
    }

    if(e.target.id == 'promocao'){
      frm.preco_reajustar = 'P';
    }

    setForm(frm);
    setRefresh(refresh+1);
  }

  const visualizarPrecos = () =>{
    if((form.novo_porc == '0')&&(form.novo_valor == '0')){
      Swal.fire('Atenção','Por favor informe o valor a ser calculado!','warning');
      return;
    }

    if(form.preco_reajustar == ''){
      Swal.fire('Atenção','Por favor informe qual preço será reajustado!','warning');
      return;
    }
    
    let prod = [...listaProdutos]
    let noCheck = true;

    prod.map(linha=>{
      if(linha.checked == true){
        noCheck = false;        

        let porcentagem = form.novo_porc.replace(',','.');
        porcentagem = parseFloat(porcentagem.replace(/[^0-9.]/g,'')); 
        
        let valor = form.novo_valor.replace(',','.');        
        valor = parseFloat(valor.replace(/[^0-9.]/g,'')); 

        let valorFinal = 0;

        if(form.preco_reajustar == 'V'){
          if(porcentagem > 0){
            valorFinal = parseFloat(linha.prod_prvenda) + ((parseFloat(linha.prod_prvenda) * porcentagem)/100);                             
          }
          
          if(valor > 0){
            valorFinal = valorFinal + valor;            
          }

          linha.venda_ecommerce = valorFinal.toFixed(2);
          linha.porc_categ  = '';
          linha.valor_categ = '';
          linha.porc_prod   = form.novo_porc;
          linha.valor_prod  = form.novo_valor;
        }

        if(form.preco_reajustar == 'P'){
          if(porcentagem > 0){
            valorFinal = parseFloat(linha.prod_prpromocao) + ((parseFloat(linha.prod_prpromocao) * porcentagem)/100);                             
          }
          
          if(valor > 0){
            valorFinal = valorFinal + valor;            
          }

          linha.promocao_ecommerce = valorFinal.toFixed(2);
        }
      }
    })

    if(noCheck == true){
      Swal.fire('Atenção','Nenhum produto foi selecionado','warning');
    }else{
      setListaProdutos(prod);
    }
  }

  const gravarPrecos = () =>{

    if((form.novo_porc == '0')&&(form.novo_valor == '0')){
      Swal.fire('Atenção','Por favor informe o valor ou porcentagem a ser adicionado ao produto!','warning');
      return;
    }

    if(form.preco_reajustar == ''){
      Swal.fire('Atenção','Por favor informe qual o preço a ser alterado!','warning');
      return;
    }
    
    Swal.fire({  
        title:'Confirma a gravação dos dados?',
        icon:'question',
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Sim",
        denyButtonText: `Não`}).then(result=>{
          
          if(result.isConfirmed){
            let produtos = [];
            let parametros = {};
        
            listaProdutos.map(produto =>{
              if(produto.checked == true){
                produtos.push({
                  produto_id:produto.produto_id
                });
              }
            })
        
            if(produtos.length == 0){
              Swal.fire('Atenção','Por favor selecione os produtos a serem alterados!','warning');
              return;
            }

            parametros.novo_valor         = form.novo_valor.replace(',','.').replace(/[^0-9.]/g,'');;
            parametros.novo_porc          = form.novo_porc.replace(',','.').replace(/[^0-9.]/g,'');
            parametros.filial_id          = form.filial_id.id;
            parametros.regra_pmc          = form.regra_pmc;
            parametros.integra_promocao   = form.integra_promocao;
            parametros.regra_pmc          = form.pmc;
            parametros.integra_promocao   = form.preco_reajustar == 'P' ? 'S' : 'N';
            parametros.produtos           = produtos;
        
            const url = rotas.ecommerceProdutos;
        
            const retorno = rest.post(url,parametros);
        
            retorno.then(ret=>{
              if(ret.success == 'S'){
                Swal.fire('Sucesso','Registro gravado com sucesso!','success');
              }else{
                Swal.fire('Erro','Erro na gravação dos dados!','error');
              }
            })
          }
    })
  }

  return (<>

    <div className="content">
      <Modal
        isOpen={false}
        size='lg'
      >
        <FormTipoPreco></FormTipoPreco>
      </Modal>
      <Container>
        {console.log(form)}
        <Row>
          <Col md="12" className="p-0">
            <Card>

              <CardHeader>
                <CardTitle>E-Commerce</CardTitle>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col md="4">
                    <FormGroup className="mb-0">
                      <ReactSelect
                        name="tipo-preco"
                        label="Tipo de Preço"
                        placeholder="Selecione"
                        options={listaTipoPreco}
                        onChange={onChangeSelect('tipoPreco')}
                        // isDisabled={disabledLista} 
                        erro={((form.formValido == 'N') && (form.tipoPreco.id == '')) ? true : false}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>
                  {/* <Col md='1'>
                    <Button><i className="fas fa-plus"></i></Button>
                  </Col> */}
                  <Col md="4">
                    <FormGroup className="mb-0">

                      <ReactSelect
                        name="tipo-filtro"
                        label="Tipo de Filtro"
                        placeholder="Selecione"
                        options={listaTipoFiltro}
                        // defaultValue={form.tipoFiltro}            
                        onChange={onChangeSelect('tipoFiltro')}
                        // isDisabled={disabledLista}    
                        erro={((form.formValido == 'N') && (form.tipoFiltro.id == '')) ? true : false}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>

                  <Col md="4">
                    {form.tipoFiltro.id == '1' &&
                      <FormGroup>
                        <Label for="produto">Filtro</Label>
                        <Input
                          name="produto"
                          id="produto"
                          placeholder="Digite o produto"
                          onChange={onChange('produto')}
                          // defaultValue={form.produto}
                          required
                          invalid={(form.formValido == 'N') ? true : false}
                          valid={(form.formValido == 'S') ? true : false}
                        />
                      </FormGroup>
                    }

                    {(form.tipoFiltro.id == '2' || form.tipoFiltro.id == '') &&
                      <FormGroup>
                        <ReactSelect
                          name="categoria"
                          label="Filtro"
                          placeholder="Selecione a categoria"
                          options={listaCategoria}
                          // defaultValue={{ id: form.categoria_id, title: form.categoria.title ? form.categoria.title : form.categoria }}
                          onChange={onChangeSelect('categoria_id')}
                          erro={((form.formValido == 'N') && (form.categoria_id.id == '')) ? true : false}
                        >
                        </ReactSelect>
                      </FormGroup>
                    }


                  </Col>
                  {/* <Col md='1'>
                    <Button><i className="fas fa-plus"></i></Button>
                  </Col> */}

                  <Col md="4">
                    <FormGroup>
                      <ReactSelect
                        name="filial_id"
                        label="Loja"
                        placeholder="Selecione"
                        options={listaLojas}
                        isMulti
                        // defaultValue={{ id: form.fornecedor_id, title: form.fornecedor.title ? form.fornecedor.title : form.fornecedor }}
                        onChange={onChangeSelect('filial_id')}
                        erro={((form.formValido == 'N') && (form.filial_id.id == '')) ? true : false}
                      >
                      </ReactSelect>
                    </FormGroup>
                  </Col>


                  <Col md="5">
                    <FormGroup className="card-2 d-flex justify-content-between">
                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            type="checkbox"
                            id="prod_saldo"
                            onChange={onChange('prod_saldo')}
                            // onClick={setTributacaoMonofasica}
                            defaultChecked={form.prod_saldo === 'S' ? true : false}
                          />
                          <span className="form-check-sign" />{'Saldo > 0'}
                        </Label>
                      </FormGroup>{" "}

                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            type="checkbox"
                            id="promocional"
                            onChange={onChange('promocional')}
                            // onClick={setTributacaoMonofasica}
                            defaultChecked={form.promocional === 'S' ? true : false}
                          />
                          <span className="form-check-sign" />{'Promocional'}
                        </Label>
                      </FormGroup>{" "}

                      <FormGroup check inline className="mb-0">
                        <Label check>
                          <Input
                            type="checkbox"
                            id="sem-pmc"
                            onChange={onChange('pmc')}
                            // onClick={setTributacaoMonofasica}
                            defaultChecked={form.pmc === 'S' ? true : false}
                          />
                          <span className="form-check-sign" />{'Sem PMC'}
                        </Label>
                      </FormGroup>{" "}

                    </FormGroup>
                  </Col>

                  <Col className='py-3'>
                    {/* <FormGroup> */}
                      <Button block onClick={listarProdutos}>Buscar</Button>
                    {/* </FormGroup> */}
                  </Col>

                </Row>

                  <span className="border-top d-block"></span>
                <Row>
                  <Col>
                    <FormGroup>
                      <Label for="prod_prcompra">Porcent. %</Label>
                      <NumberFormat
                        required
                        name="novo_porc"
                        id="novo_porc"
                        placeholder="0.00"
                        value={form.novo_porc.replace('.', ',')}
                        onChange={onChange('novo_porc')}
                        maxLength={20}
                        decimalScale={2}
                        allowNegative={false}
                        className={"form-control"}
                        // prefix={"R$ "}                        
                        decimalSeparator={','}
                        fixedDecimalScale
                      />
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup>
                      <Label for="novo_valor">Valor a ser adicionado R$</Label>
                      <NumberFormat
                        required
                        name="novo_valor"
                        id="novo_valor"
                        placeholder="0.00"
                        value={form.novo_valor.replace('.', ',')}
                        onChange={onChange('novo_valor')}
                        maxLength={20}
                        decimalScale={2}
                        allowNegative={false}
                        className={"form-control"}
                        prefix={"R$ "}
                        decimalSeparator={','}
                        fixedDecimalScale
                      />
                    </FormGroup>
                  </Col>

                  <Col className="pt-4">
                    <FormGroup check inline className="mb-0">
                      <Label check>
                        <Input
                          type="checkbox"
                          id="venda"
                          onChange={onChangeReajuste}
                          // onClick={onChangeReajuste}
                          checked={form.preco_reajustar == 'V' ? true : false}
                        />
                        <span className="form-check-sign" />{'Venda'}
                      </Label>
                    </FormGroup>{" "}

                    <FormGroup check inline className="mb-0">
                      <Label check>
                        <Input
                          type="checkbox"
                          id="promocao"
                          onChange={onChangeReajuste}
                          // onClick={onChangeReajuste}
                          checked={form.preco_reajustar === 'P' ? true : false}
                        />
                        <span className="form-check-sign" />{'Promoção'}
                      </Label>
                    </FormGroup>{" "}

                  </Col>

                  <Col className='d-flex justify-content-center py-2'>
                  <Button color='info' onClick={visualizarPrecos}>Visualizar</Button>
                  <Button color = 'success' onClick={gravarPrecos}>Gravar</Button>
                  </Col>

                </Row>
                <Row>
                  <Col>
                    <DataTableEcommerce
                      columns={colunas}
                      data={listaProdutos}
                      // readOnly={readOnlyTable}
                      setData={setListaProdutos}
                      checkAll={checkAll}
                      onlyChecked={false}
                    // recalculaMargemMkp={recalculaMargemMkp}
                    // setColumn={setColunas}
                    // gravaPosicaoColunas={gravaPosicaoColunas}
                    >
                    </DataTableEcommerce>
                  </Col>

                  <Col>
                    {loading && <Loading tipo='componente'></Loading>}
                  </Col>

                </Row>

                <Row>
                  <Col className='text-center'>
                    <Button onClick={()=>{closeModal()}}>Fechar</Button>
                  </Col>
                </Row>

              </CardBody>
            </Card>
          </Col>
        </Row>

      </Container>
    </div >

  </>)
}

export default FormProdutosEcommerce;